import * as React from "react"
import Tooltip from "rc-tooltip"
import { Link } from "gatsby"
import "rc-tooltip/assets/bootstrap.css"
import Icon from "@mdi/react"
import { mdiBird, mdiGithub, mdiConsole } from "@mdi/js"
import { MeltingFace } from "react-blobmoji"

const Links = () => (
  <>
    <Tooltip placement="bottom" overlay={<span>公開している制作物など</span>}>
      <Link
        to="/works"
        className="px-1 lg:py-1 text-zinc-700 hover:text-zinc-500 active:text-zinc-200 visited:text-zinc-700"
      >
        <Icon path={mdiConsole} size={1} />
      </Link>
    </Tooltip>
    <Tooltip
      placement="bottom"
      overlay={
        <div className="inline-flex items-center">
          <span className="mr-px">GitHub</span>
        </div>
      }
    >
      <a
        href="https://github.com/miiton"
        className="px-1 lg:py-1 text-zinc-700 hover:text-zinc-500 active:text-zinc-200 visited:text-zinc-700"
      >
        <Icon path={mdiGithub} size={1} />
      </a>
    </Tooltip>
    <Tooltip
      placement="bottom"
      overlay={
        <div className="inline-flex items-center">
          <span className="mr-px">Twitter</span>
        </div>
      }
    >
      <a
        href="https://twitter.com/miiton"
        className="px-1 lg:py-1 text-zinc-700 hover:text-zinc-500 active:text-zinc-200 visited:text-zinc-700"
      >
        <Icon path={mdiBird} size={1} />
      </a>
    </Tooltip>
  </>
)

const Header = ({ siteMetaData }) => {
  return (
    <>
      <div className="flex justify-between items-end">
        <div className="flex flex-col w-full">
          <div className="flex justify-between">
            <Link
              to="/"
              onTouchStart={() => {}}
              className="block px-4 py-1 font-bold text-black hover:text-black visited:text-black text-3xl active:bg-zinc-100 lg:hover:bg-zinc-100 lg:active:bg-zinc-200 inline-flex items-center"
            >
              <span>{siteMetaData.title}</span>
              <div className="w-10">
                <MeltingFace size="100%" className="inline" />
              </div>
            </Link>
            <div className="py-1 px-4 flex items-center block lg:hidden">
              <Links />
            </div>
          </div>
          <p className="px-4 mb-2 text-zinc-700 text-xs sm:text-sm">
            {siteMetaData.description}
          </p>
        </div>
        <div className="py-1 items-center hidden lg:flex">
          <Links />
        </div>
      </div>
    </>
  )
}

export default Header
